﻿import React from 'react';
import RawHtml from '../../../../UI/RawHtml';

const HomeText = (props) => {

    return (
        <div className="col-1-2">
            <div className="text">
                <h2>{props.heading}</h2>
                <RawHtml>{props.text}</RawHtml>              
            </div>           
        </div>
     )
 }                

export default HomeText;